// extracted by mini-css-extract-plugin
export default {"quantityCategory":"quantityCategory__16G8T","categoryName":"categoryName__8pzUK"};
    if(module.hot) {
      // 1745482222193
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  